export const getWhatsappLink = (phoneNumber = '') => {
  if (!phoneNumber) {
    return '';
  }

  const internationalFormat = phoneNumber.replace(/^0/, '62');

  return `https://wa.me/${internationalFormat}`;
};
